import * as moment from 'moment';

import { TimeUnit, DayOfWeek } from '../../../models';
import { IAlignmentStrategy } from './IAlignmentStrategy';

export class MonthAlignmentStrategy implements IAlignmentStrategy {
    align(
        input: moment.Moment,
        beginTime: moment.Duration,
        interval: number,
        intervalTimeUnit: TimeUnit,
        dayOfWeek: DayOfWeek
    ): moment.Moment {
        let result: moment.Moment = null;

        if (intervalTimeUnit === TimeUnit.Month) {
            let month = input.month();

            if (input.date() !== 1
                || (input.month() % interval) > 0
                || (input.date() === 1 && (input.month() % interval) === 0 && input.hours() > beginTime.hours()))
            {
                //result = result.add(interval - (result.month() % interval), 'M');
                month += interval - (month % interval);
            }

            result = moment()
                .year(input.year())
                .month(month)
                .date(1)
                .hours(0)
                .minutes(0)
                .seconds(0)
                .milliseconds(0)
                .add(beginTime.asMinutes(), 'm');
        }

        return result;
    }
}
